import './App.css';
import LindaLashesWebsite from './pages/LindaLashes';

function App() {
  return (
    <div className="App">
      <LindaLashesWebsite />
    </div>
  );
}

export default App;